module.exports = __webpack_public_path__ + "img/新闻 list.ba504bac.png";